// Active state for sidebar nav items: faint primary tint, bolder text,
// and a thin primary border (via inset-ring so it doesn't shift layout).
export const SIDEBAR_ITEM_ACTIVE_CLASSES
  = 'bg-primary-50 hover:bg-primary-100 text-primary-700 hover:text-primary-800 font-medium '
    + 'inset-ring inset-ring-primary-200 hover:inset-ring-primary-300';
